import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormSpy } from 'react-final-form';

// state management
import { getIsConnectionFailedMessageVisible, getLogin } from '../selectors/login';
import { openForgotPasswordModal } from '../actions/auth';
import { loginAccount } from '../actions/login';
import { composeValidators, required, email } from '../helpers/formValidators';

// components
import { FormLabel, FormInput, FormFeedback, BaseForm } from './form';
import { PrimaryButton } from './buttons';

const Login = (props) => {
  const {
    isLoading,
    onOpenForgotPassword,
    handleOpenSignUpModal,
    closeLoginModal,
    connectionFailed,
    isIncorrectPasswordMessageVisible,
    location,
    loginAccount,
    history,
    t
  } = props;

  const [isReferred, setIsReferred] = useState(false);

  useEffect(() => {
    if (
      location &&
      location.state &&
      location.state.from &&
      location.state.from.state
    ) {
      setIsReferred(!isReferred);
    }
  }, [location])

  const handleLogin = (values) => {
    loginAccount({
      email: values.email.trim(),
      password: values.password.trim()
    }, history);
  }

  return (
    <div>
      <div className="page-header">
        <h3>Log In</h3>
      </div>

      <div className="login-container container">
        <BaseForm className="login-form" onSubmit={handleLogin}>
          <p>Log in with your IWK Chez NICU Home account. Don't have an account &nbsp;
            <a
              className="text-link"
              onClick={() => { closeLoginModal(); handleOpenSignUpModal(); }}
            >
              Sign Up
            </a>
          </p>

          {isReferred && (
            <FormFeedback positive>
              {t('login.messageAuthRequired')}
            </FormFeedback>
          )}

          <FormLabel for="login.email">
            Email
          </FormLabel>

          <FormInput
            disabled={isLoading}
            id="login.email"
            validate={composeValidators(required, email)}
            name="email"
            type="email"
          />

          <FormLabel for="login.password">
            Password
          </FormLabel>

          <FormInput
            disabled={isLoading}
            id="login.password"
            name="password"
            type="password"
            validate={composeValidators(required)}
          />

          {isIncorrectPasswordMessageVisible && (
            <FormFeedback positive={false}>E-mail or password is incorrect</FormFeedback>
          )}

          {connectionFailed && (
            <FormFeedback positive={false}>No internet connection</FormFeedback>
          )}

          <div className="login-container__footer">
            <FormSpy subscription={{ submitting: true }}>
              {({ submitting }) => (
                <PrimaryButton
                  type="submit"
                  label="Log In"
                  disabled={submitting || connectionFailed}
                />
              )}
            </FormSpy>

            <button
              className="text-link login__forgot-password-button"
              type="button"
              onClick={onOpenForgotPassword}
            >
              Forgot Your Password?
            </button>
          </div>
        </BaseForm>
      </div>
    </div>
  );
}

Login.propTypes = {
  isIncorrectPasswordMessageVisible: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isConnectionFailedMessageVisible: PropTypes.bool.isRequired,
  onOpenForgotPassword: PropTypes.func,
  closeLoginModal: PropTypes.func,
  handleOpenSignUpModal: PropTypes.func
};

const mapStateToProps = state => (
  {
    connectionFailed: getIsConnectionFailedMessageVisible(state),
    loginProps: getLogin(state)
  }
);

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loginAccount,
      openForgotPasswordModal
    },
    dispatch
);

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/components/Login.js